import { render, staticRenderFns } from "./ManagerArea.vue?vue&type=template&id=77664fbb&scoped=true&"
import script from "./ManagerArea.vue?vue&type=script&lang=js&"
export * from "./ManagerArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77664fbb",
  null
  
)

export default component.exports